import { ReactNode } from 'react'
import styles from './Skeleton.module.scss'

export const SkeletonText = ({ type = 'normal', lines = 1 }: { type: 'normal' | 'large', lines: number} ) => {
    const rnd = Math.random() * 100
    const items = Array.from({ length: lines }).map((_, index: number) => {
        return <div className={`${styles.skeletonText} ${styles[type]}`} key={`${rnd}-${index + 1}`}></div>
    })

    return <div className={styles.skeleton}>{items}</div>
}

export const SkeletonSquare = () => {
    return <div className={styles.skeletonSquare}></div>
}

export const SkeletonList = ({ children }: { children: ReactNode}) => {
    return <div className={styles.skeletonList}>{children}</div>
}